module.exports = {
    BaseStore: require('./BaseStore'),
    createStore: require('./createStore')
};
